import { IconButton, Link, TableCell } from "@material-ui/core";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import { Collection } from '@type-r/models';
import { Linked, useLinked } from "@type-r/react";
import { asDateTime, CollapsableSection, CompactTextArea, FormLabel, FormValue, InlineTable, PopupIODialog, ReadOnly, SelectFile, TableRow, FormSelect, Option } from "lqx-react";
import * as React from "react";
import { useContext } from "react";
import { Document } from 'api';
import { UploadSupportModel } from 'api/common';

export interface AttachmentProps {
    $dialog: Linked<String>;

    uploads: Collection<Document>;
    disabledAdd?: boolean;
    disabledRemove?: boolean;
}

export const Attachments = ({ $dialog, uploads, disabledAdd, disabledRemove }: AttachmentProps) => {
    const readOnly = useContext(ReadOnly);

    return (
        <CollapsableSection
            id="documents"
            title="Documents"
            right={
                !readOnly && !disabledAdd ?
                    <IconButton aria-label="Add Document" size="small" onClick={e => {
                        e.stopPropagation();
                        $dialog.set('upload');
                    }}>
                        <AddCircleIcon />
                    </IconButton>
                    : null
            }
        >
            <InlineTable noBorders>
                {uploads.map(upload =>
                    <TableRow key={upload.cid}>
                        <TableCellDocumentType type={upload.document_type} />
                        <TableCell>
                            <Link onClick={() => upload.download()}>{upload.file_name}</Link>
                        </TableCell>

                        <TableCell className="fit-width">
                            <FormValue>{upload.uploader}</FormValue>
                        </TableCell>
                        <TableCell className="fit-width">
                            <FormLabel>{asDateTime(upload.upload_timestamp)}</FormLabel>
                        </TableCell>
                        {!readOnly && !disabledRemove ?
                            <TableCell className="fit-width">
                                <IconButton aria-label="Remove Document" onClick={() => upload.destroy()}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                            : null}
                    </TableRow>
                )}
            </InlineTable>
        </CollapsableSection>
    )
}

export const TableCellDocumentType = ({ type }) => {
    const docType = type && type != 'null' ? type.replace(/([a-z])([A-Z])/g, '$1 $2') : 'Other'
    return (
        <TableCell style={{ width: 125 }}>{docType}</TableCell>
    );
}

const UploadTypeSection = ({ model, $uploadType }) => {
    //must be in unvalidated or po pending to see upload type section
    if (!['Unvalidated', 'PO Pending'].includes(model['status']))
        return null

    return (
        <div style={{ marginTop: '-2px', fontSize: '9px', float: 'left', width: '50%', position: 'absolute', marginLeft: '5px', height: '0px' }}>
            <label style={{ marginBottom: '2px' }}>Type</label><br />
            <label style={{ marginBottom: '0px' }} onClick={() => $uploadType.set('purchase_order_pdf')}>
                <input style={{ marginLeft: '3px' }} name="uploadType" type="radio" id="purchase_order_pdf" value="purchase_order_pdf" defaultChecked />
                <span style={{ position: 'absolute', marginLeft: '2px' }}>Purchase Order PDF</span>
            </label><br />
            <label onClick={() => $uploadType.set('other')}>
                <input style={{ marginLeft: '3px' }} name="uploadType" type="radio" id="other" value="other" />
                <span style={{ position: 'absolute', marginLeft: '2px' }}>Other</span>
            </label>
        </div>
    )
}

export const UploadDialog = ({ $isOpen, model }: {
    $isOpen: Linked<boolean>
    model: UploadSupportModel
}) => {
    const $file = useLinked(null),
        file = $file.value,
        $documentType = useLinked(null);

    const $uploadType = useLinked('purchase_order_pdf');
    const $comment = useLinked('');
    return (
        <ReadOnly.Provider value={false}>
            <PopupIODialog
                title="Upload Documents"
                $isOpen={$isOpen}
                actionLabel="Upload"
                success="Documents are uploaded"
                disabled={!file}
                doIO={() => model.doUpload(file, $comment.value, $uploadType.value, $documentType)}>

                <FormSelect $value={$documentType} label="Document Type" >
                    <Option value="Invoice">Invoice</Option>
                    <Option value="Dispute">Dispute</Option>
                    <Option value="Other">Other</Option>
                </FormSelect>

                <CompactTextArea autoFocus label="Comment" rows={10} $value={$comment} />
                <SelectFile accept=".csv,.edi,.xml,.txt,.json,.pdf,.xls,.doc,.docx,.xlsx,.png,.jpeg" label="Attachment" $value={$file} />
                <UploadTypeSection model={model} $uploadType={$uploadType} />

            </PopupIODialog>

        </ReadOnly.Provider>
    )
}
